import { Icon, SvgFullscreen, SvgFullscreenExit } from '@loomhq/lens';
import React from 'react';

import ControlBarButton from '../control-bar-button';

import './styles.less';

export default function FullscreenButton(props) {
  const hoverTagText = props.fullScreen
    ? 'Exit Full Screen (f)'
    : 'Enter Full Screen (f)';

  return (
    <ControlBarButton
      className="video-player-fullscreen-button"
      hoverTagText={hoverTagText}
      seeking={props.seeking}
      onClick={props.onClick}
    >
      <Icon
        className="control-bar-button-icon"
        color="white"
        icon={props.fullScreen ? <SvgFullscreenExit /> : <SvgFullscreen />}
      />
    </ControlBarButton>
  );
}
